import React from "react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom";
import "./index.scss";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "./store/reducers/index";
import theme from "./utils/theme";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "./utils/global";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import environment from "./environments/index";
import { GoogleOAuthProvider } from "@react-oauth/google";


const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["profile", "general", "register", "anteProyecto", "backoffice", "dashboard", "registrationV2", "onboardingV2"],
};

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
  Sentry.init({
    dsn: environment.SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    environment: environment.env,
    tracesSampleRate: environment.env === 'production' ? 0.1 : 0.5,
    replaysSessionSampleRate: environment.env === 'production' ? 0.1 : 0.5,
    replaysOnErrorSampleRate: 1.0,
    debug: false,
  });
}

const pReducer = persistReducer(persistConfig, reducers);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(pReducer, composeEnhancers(applyMiddleware(thunk)));
export const persistor = persistStore(store);

const Index = () => {

  return (
    <GoogleOAuthProvider clientId={environment.googleOAuth.clientId}>
      <Provider store={store}>
        <PersistGate loading={<p>Cargando</p>} persistor={persistor}>
          <BrowserRouter>
            <ThemeProvider theme={theme}>
              <>
                <App />
                <GlobalStyles />
              </>
            </ThemeProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<Index />);

serviceWorker.unregister();

